import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestsComponent implements OnInit {

    constructor(
        public gs: GeneralService) {

    }

    ngOnInit() {
    }

}
